export default __webpack_public_path__ + "static/media/1713.d1048009.png";